<template>
  <div class="order-status-page">
    <div class="status-header">
      <b-form-group class="status-control mb-1">
        <div class="status-control-inner">
          <label class="status-label">Status</label>

          <b-form-radio-group v-model="status">
            <b-form-radio
              value="2"
              class="status-radio"
            >
              au depot
            </b-form-radio>
          </b-form-radio-group>

        </div>
      </b-form-group>
      <div>
        <b-form-group class="mb-1">
          <label class="orders-count">Nombre de colis: {{ items.length }}</label>
        </b-form-group>
      </div>
    </div>
    <b-form-group
      v-if="user.role === 'admin' || user.role === 'superadmin'"
      label="Depot"
      class="repository-field"
    >
      <validation-provider
        #default="{ errors }"
        name="Depot"
      >
        <v-select
          v-model="repository"
          :clearable="false"
          placeholder="Depots"
          label="name"
          :options="repositories"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-form-group
      label="Référence"
      class="reference-field"
    >
      <b-input-group class="input-group-merge scan-input-group">
        <b-input-group-prepend is-text>
          <feather-icon icon="MaximizeIcon" />
        </b-input-group-prepend>
        <b-form-input
          ref="select"
          v-model="ref"
          placeholder="Référence de colis"
          @change="checkOrder"
        />
        <b-input-group-append>
          <b-button
            :variant="isPhoneScanning ? 'danger' : 'outline-primary'"
            :disabled="isStartingCamera || !canUseCameraScanner"
            class="phone-scanner-button"
            @click="togglePhoneScanner"
          >
            <feather-icon
              :icon="isPhoneScanning ? 'XIcon' : 'CameraIcon'"
              class="mr-1"
            />
            {{ isPhoneScanning ? 'Arrêter' : 'Scanner téléphone' }}
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-alert
      v-if="!canUseCameraScanner"
      variant="warning"
      show
      class="mb-2"
    >
      Le scan caméra nécessite HTTPS ou localhost sur le téléphone. Utilisez une URL sécurisée ou le champ référence.
    </b-alert>
    <b-card
      v-if="isPhoneScanning || isStartingCamera"
      class="mb-2 phone-scanner-card"
      body-class="p-1"
    >
      <div
        v-if="isStartingCamera"
        class="d-flex align-items-center justify-content-center scanner-loading"
      >
        <b-spinner
          small
          variant="primary"
          class="mr-1"
        />
        Ouverture caméra...
      </div>
      <div
        v-show="isPhoneScanning"
        class="phone-scanner-frame"
      >
        <video
          ref="phoneScannerVideo"
          class="phone-scanner-video"
          autoplay
          muted
          playsinline
        />
        <div class="phone-scanner-target" />
      </div>
    </b-card>
    <b-card class="orders-reception-card">
      <h4 class="mb-2 reception-title">
        Reception Centrale
      </h4>
      <b-table
        hover
        responsive
        stacked="sm"
        :items="items"
        :fields="fields"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BCard,
  BTable,
  BFormRadio,
  BFormRadioGroup,
  BButton,
  BAlert,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import storeAuth from '@/store/store'
import vSelect from 'vue-select'
import jsQR from 'jsqr'
import { ValidationProvider } from 'vee-validate'
import reception from '@/assets/audio/reception.mp3'
import alreadyScanned from '@/assets/audio/colis-deja-scanne.mp3'
import notexist from '@/assets/audio/notexist.mp3'
import alreadyAtDepot from '@/assets/audio/colis-deja-au-depot.mp3'

export default {
  components: {
    BFormRadio,
    BFormRadioGroup,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BCard,
    BTable,
    BButton,
    BAlert,
    BSpinner,
    vSelect,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      status: 2,
      items: [],
      item: {},
      repositories: [],
      repository: {},
      user: {},
      fields: [
        { key: 'code', label: 'Référence colis' },
        { key: 'client', label: 'Destinataire' },
        { key: 'gouvernorat', label: 'Gouvernorat' },
        { key: 'adresse', label: 'Adresse de livraison' },
        { key: 'téléphone', label: 'Téléphone principal' },
      ],
      ref: '',
      canUseCameraScanner: typeof navigator !== 'undefined' && !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia),
      isPhoneScanning: false,
      isStartingCamera: false,
      phoneScannerStream: null,
      phoneScannerDetector: null,
      phoneScannerFrameId: null,
      phoneScannerCanvas: null,
      phoneScannerCanvasContext: null,
      isProcessingPhoneScan: false,
      lastScannedRef: '',
      lastScannedAt: 0,
      synth: window.speechSynthesis,
      voiceList: [],
      reception,
      alreadyScanned,
      notexist,
      alreadyAtDepot,
    }
  },
  created() {
    this.user = storeAuth.state.user
    this.getRepositories()
  },
  mounted() {
    this.$refs.select.focus()
  },
  beforeDestroy() {
    this.stopPhoneScanner()
  },
  methods: {
    async getRepositories() {
      const { data } = await axios.get('/api/repositories/')
      this.repositories = data
    },
    exists(id) {
      return this.items.some(el => el.code === (id))
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    async withTitle(text) {
      try {
        await this.$swal({
          title: 'Alerte',
          icon: 'warning',
          text,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
        this.ref = ''
      } catch (e) {
        this.ref = ''
      }
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
    async updateStatus() {
      try {
        await axios.post('/api/orders/change-status-deposit/', {
          order: this.item,
        })
        this.status = 2
        this.showToast('success', 'top-center', 'Status modifié avec succés')
        this.playAudio(reception)
      } catch (error) {
        this.showToast('danger', 'top-center', error.toString())
      }
    },
    async playAudio(payload) {
      const voice = new Audio(payload)
      voice.addEventListener('canplaythrough', () => {
        voice.play()
      })
    },
    async checkOrder() {
      const scannedRef = this.ref ? this.ref.toString().trim() : ''
      if (!scannedRef) return
      let repository = null
      if (storeAuth.state.user.role === 'admin' || storeAuth.state.user.role === 'superadmin') {
        repository = this.repository.id
      } else {
        repository = storeAuth.state.user.repository
      }
      const result = this.items.find(element => element.code.toString() === scannedRef)
      if (result) {
        this.withTitle('Colis déjà scanné')
        this.playAudio(alreadyScanned)
      } else {
        try {
          const response = await axios
            .get('/api/orders/get-status-waiting-picked/', {
              params: {
                id: scannedRef,
                repository,
              },
            })
          if (response.data.length !== 0) {
            const order = response.data[0]
            this.item = {
              code: order.id,
              repository: order.repository.name,
            }
            this.items.push({
              code: order.id,
              client: order.name,
              gouvernorat: order.governorate.name,
              adresse: order.address,
              téléphone: order.phone1,
              repository: order.repository.name,
            })
            this.updateStatus()
            this.ref = ''
          } else {
            // Order not in waiting/picked status - check if it exists and its status
            try {
              const checkOrder = await axios.get(`/api/orders/detail/${scannedRef}/`)
              // Order exists, check if it's at depot (status = 2)
              if (checkOrder.data && checkOrder.data.status === 2) {
                this.withTitle('Colis déjà au dépot')
                this.playAudio(alreadyAtDepot)
              } else {
                // Order exists but not available for this depot
                this.withTitle('Colis non existant')
                this.playAudio(notexist)
              }
            } catch (checkError) {
              // Order doesn't exist at all
              this.withTitle('Colis non existant')
              this.playAudio(notexist)
            }
            this.ref = ''
          }
        } catch (error) {
          // Check if error is about order already at depot
          if (error.response && error.response.data) {
            const errorMessage = error.response.data.message || error.response.data.error || ''
            if (errorMessage.toLowerCase().includes('depot') || errorMessage.toLowerCase().includes('dépot')) {
              this.withTitle('Colis déjà au dépot')
              this.playAudio(alreadyAtDepot)
            } else {
              this.withTitle('Colis non existant')
              this.playAudio(notexist)
            }
          } else {
            this.withTitle('Colis non existant')
            this.playAudio(notexist)
          }
          this.ref = ''
        }
      }
    },
    async togglePhoneScanner() {
      if (this.isPhoneScanning || this.isStartingCamera) {
        this.stopPhoneScanner()
      } else {
        await this.startPhoneScanner()
      }
    },
    async startPhoneScanner() {
      if (!this.canUseCameraScanner) return
      this.isStartingCamera = true
      try {
        if (typeof window !== 'undefined' && 'BarcodeDetector' in window) {
          this.phoneScannerDetector = new window.BarcodeDetector({ formats: ['qr_code'] })
        } else {
          this.phoneScannerDetector = null
        }
        this.phoneScannerCanvas = document.createElement('canvas')
        this.phoneScannerCanvasContext = this.phoneScannerCanvas.getContext('2d', { willReadFrequently: true })
        this.phoneScannerStream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: { ideal: 'environment' },
          },
          audio: false,
        })
        this.isPhoneScanning = true
        await this.$nextTick()
        const video = this.$refs.phoneScannerVideo
        video.srcObject = this.phoneScannerStream
        await video.play()
        this.scanPhoneCameraFrame()
      } catch (error) {
        this.showToast('danger', 'top-center', 'Impossible d’ouvrir la caméra pour scanner le QR code')
        this.stopPhoneScanner()
      } finally {
        this.isStartingCamera = false
      }
    },
    stopPhoneScanner() {
      if (this.phoneScannerFrameId) {
        window.cancelAnimationFrame(this.phoneScannerFrameId)
        this.phoneScannerFrameId = null
      }
      if (this.phoneScannerStream) {
        this.phoneScannerStream.getTracks().forEach(track => track.stop())
        this.phoneScannerStream = null
      }
      this.phoneScannerCanvas = null
      this.phoneScannerCanvasContext = null
      this.phoneScannerDetector = null
      this.isPhoneScanning = false
    },
    async scanPhoneCameraFrame() {
      if (!this.isPhoneScanning || !this.$refs.phoneScannerVideo) return
      try {
        const codes = this.phoneScannerDetector
          ? await this.phoneScannerDetector.detect(this.$refs.phoneScannerVideo)
          : []
        if (codes.length && codes[0].rawValue) {
          await this.handlePhoneQrScan(codes[0].rawValue)
        } else {
          const decodedValue = this.decodeQrFromVideoFrame()
          if (decodedValue) {
            await this.handlePhoneQrScan(decodedValue)
          }
        }
      } catch (error) {
        this.showToast('danger', 'top-center', 'Erreur pendant la lecture du QR code')
        this.stopPhoneScanner()
        return
      }
      this.phoneScannerFrameId = window.requestAnimationFrame(this.scanPhoneCameraFrame)
    },
    decodeQrFromVideoFrame() {
      const video = this.$refs.phoneScannerVideo
      if (!video || !this.phoneScannerCanvas || !this.phoneScannerCanvasContext) return ''
      if (!video.videoWidth || !video.videoHeight) return ''

      this.phoneScannerCanvas.width = video.videoWidth
      this.phoneScannerCanvas.height = video.videoHeight
      this.phoneScannerCanvasContext.drawImage(video, 0, 0, video.videoWidth, video.videoHeight)
      const imageData = this.phoneScannerCanvasContext.getImageData(0, 0, video.videoWidth, video.videoHeight)
      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: 'dontInvert',
      })

      return code && code.data ? code.data : ''
    },
    async handlePhoneQrScan(rawValue) {
      const scannedRef = this.extractOrderReference(rawValue)
      if (!scannedRef) return
      if (this.isProcessingPhoneScan) return

      const now = Date.now()
      if (this.lastScannedRef === scannedRef && now - this.lastScannedAt < 2000) {
        this.lastScannedAt = now
        return
      }
      this.lastScannedRef = scannedRef
      this.lastScannedAt = now

      this.isProcessingPhoneScan = true
      try {
        this.ref = scannedRef
        await this.checkOrder()
      } finally {
        this.isProcessingPhoneScan = false
      }
    },
    extractOrderReference(rawValue) {
      const value = rawValue ? rawValue.toString().trim() : ''
      if (!value) return ''

      try {
        const url = new URL(value)
        const queryRef = url.searchParams.get('order_id')
          || url.searchParams.get('order')
          || url.searchParams.get('id')
          || url.searchParams.get('ref')
          || url.searchParams.get('barcode')
        if (queryRef) return queryRef.trim()

        const pathParts = url.pathname.split('/').filter(Boolean)
        if (pathParts.length) return pathParts[pathParts.length - 1].trim()
      } catch (error) {
        // Plain order IDs and cross-tenant barcodes are expected for printed QR codes.
      }

      return value
    },
  },
}
</script>
<style lang="scss" >
@import "@core/scss/vue/libs/vue-select.scss";

.order-status-page {
  width: 100%;
}

.status-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.status-control-inner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.status-label,
.orders-count {
  margin: 0;
  color: #111827;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.3;
}

.status-radio {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.3;
}

.repository-field,
.reference-field {
  width: 100%;
}

.scan-input-group {
  width: 100%;
}

.phone-scanner-button {
  white-space: nowrap;
}

.phone-scanner-card {
  width: 100%;
  max-width: 520px;
}

.scanner-loading {
  min-height: 220px;
}

.phone-scanner-frame {
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 520px;
  aspect-ratio: 4 / 3;
  background: #111;
  border-radius: 6px;
}

.phone-scanner-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.phone-scanner-target {
  position: absolute;
  top: 18%;
  right: 18%;
  bottom: 18%;
  left: 18%;
  border: 2px solid rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  box-shadow: 0 0 0 999px rgba(0, 0, 0, 0.22);
  pointer-events: none;
}

.orders-reception-card {
  overflow: hidden;
}

.reception-title {
  color: #111827;
  font-size: 1.25rem;
  font-weight: 600;
}

@media (max-width: 575.98px) {
  .status-header {
    flex-direction: column;
    gap: 0.25rem;
  }

  .status-control {
    width: 100%;
  }

  .status-control-inner {
    justify-content: space-between;
  }

  .status-label,
  .orders-count,
  .reception-title {
    font-size: 1rem;
  }

  .status-radio {
    font-size: 0.95rem;
  }

  .repository-field,
  .reference-field,
  .scan-input-group {
    max-width: none;
    width: 100%;
  }

  .scan-input-group {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .scan-input-group > .input-group-prepend {
    flex: 0 0 auto;
  }

  .scan-input-group > .form-control {
    min-width: 0;
  }

  .scan-input-group > .input-group-append {
    flex: 0 0 100%;
    margin-top: 0.5rem;
    margin-left: 0;
  }

  .scan-input-group > .input-group-append .btn,
  .phone-scanner-button {
    width: 100%;
    border-radius: 0.357rem;
  }

  .phone-scanner-card {
    max-width: none;
  }

  .phone-scanner-frame {
    max-width: none;
    aspect-ratio: 3 / 4;
  }
}
</style>
